

import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import ServicesGrid from './components/ServicesGrid';
import ProcessSection from './components/ProcessSection';
import AboutSection from './components/AboutSection';
import TrustBadges from './components/TrustBadges';
import StatsSection from './components/StatsSection';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <div className="min-h-screen" dir="rtl">
      <Header />
      <main>
        <HeroSection />
        <AboutSection />
        <ServicesGrid />
        <ProcessSection />
        <TrustBadges />
        <StatsSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}